// extracted by mini-css-extract-plugin
export default {"header":"Landing_header__CDdXf","logo":"Landing_logo__oUlXx","stackButtons":"Landing_stackButtons__CsQTg"};